import {
  UserFrontScreensParams,
  useUserFrontNavigation,
} from '@psl/flows/me/screens';
import { WithID } from '@psl/functions/firebase/rxfireExtensions';
import { useCreation } from '@psl/functions/hooks/useCreation';
import { Profile } from '@psl/models/ClientModels';
import { StackNavigationProp } from '@react-navigation/stack';
import React, { memo, ReactNode, useContext, useMemo } from 'react';
import { BehaviorSubject } from 'rxjs';

export type UserFrontContextProps = {
  userId: string | undefined;
  profile: WithID<Profile> | undefined;
  closedTips$: BehaviorSubject<string[]>;
  navigation: StackNavigationProp<UserFrontScreensParams>;
};

export const UserFrontContext = React.createContext<UserFrontContextProps>(
  null as any,
);

export const useUserFrontContext = () => useContext(UserFrontContext);

export const UserFrontContextProvider = memo(
  ({
    profile,
    children,
  }: {
    children: ReactNode;
    profile: WithID<Profile> | undefined;
  }) => {
    const userId = profile?.id;

    const closedTips$ = useCreation(
      () => new BehaviorSubject<string[]>([]),
      [],
    );

    const navigation = useUserFrontNavigation();

    const value = useMemo<UserFrontContextProps>(
      () => ({
        userId,
        profile,
        closedTips$,
        navigation,
      }),
      [userId, profile, closedTips$, navigation],
    );

    return (
      <UserFrontContext.Provider value={value}>
        {children}
      </UserFrontContext.Provider>
    );
  },
);
